
import { mapGetters } from "vuex";
import { sendAli } from "@/utils/send-ali";
import StyleSelector from "~/components/styleSelector.vue";
import AspectRatioSelector from "~/components/aspectRatioSelector.vue";
import AdvancedOptions from "~/components/Advancedoptions.vue";
import FGStyleSelector from "~/components/FG/styleSelector.vue";

export default {
  data() {
    return {
      //一些选项的配置
      localConfig: {
        prompt: "",
        style: "Generic", // 默认样式
      },
      btnDisabled: true
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  watch: {
    // 监听prompt变化
    "localConfig.prompt": {
      handler: function (newVal) {
        this.countChars();
      },
      immediate: true, // 组件创建时立即执行
    },
  },
  components: {FGStyleSelector, AdvancedOptions, AspectRatioSelector, StyleSelector },
  props: {
    language: null,
    lan: null,
    isMobile: null,
    isDisable: null,
    svgCode: null,
    load: null,
    isRemaker: null,
    aLiId: null,
    config: null,
  },
  methods: {
    navigateTo(path) {
      // 设置加载状态
      this.isLoading = true;

      // 确保导航栏保持可见
      document.body.classList.add("page-navigating");

      try {
        // 直接重置滚动位置
        if (this.isMobile) {
          window.scrollTo(0, 0);
        } else {
          const contentArea = document.querySelector(".content-area");
          if (contentArea) {
            contentArea.scrollTop = 0;
          }
        }

        // 进行路由导航，使用try-catch处理而不依赖Promise
        const navResult = this.$router.push(path);

        // 检查返回值是否为Promise
        if (navResult && typeof navResult.then === "function") {
          navResult
            .then(() => {
              this.currentPath = path;
            })
            .catch((err) => {
              // 只记录不是导航取消的错误
              if (err.name !== "NavigationDuplicated") {
                console.error("Navigation error:", err);
              }
            });
        } else {
          // 如果不是Promise，直接更新当前路径
          this.currentPath = path;
        }
      } catch (err) {
        console.error("Navigation error:", err);
      }

      // 不管成功或失败，总是在适当的时间后重置状态
      setTimeout(() => {
        document.body.classList.remove("page-navigating");
      }, 300);
    },
    // 处理样式变化
    onStyleChange(style) {
      this.localConfig.style = style;
    },
    // 获取选中的style
    getStyle() {
      return this.localConfig.style || this.config.defaultStyle;
    },
    // 点击开始生成
    async tapGenerate() {
      if (this.charCount > 60) {
        sendAli(this.aLiId, "generate_image_char_limit", {
          style: this.localConfig.style,
          aspectRatio: this.localConfig.aspectRatio,
          bodyPart: this.localConfig.bodyPart,
          payment: this.getUserInfo.payment ? 1 : 2,
          prompt: this.localConfig.prompt,
        });
        await this.$alert(this.$t("fontLimitExceeded"), this.$t("notice"), {
          confirmButtonText: this.$t("sure"),
        });
        return;
      }
      // 显示加载状态
      this.$root.$emit("content-loading");

      this.btnDisabled = true;
      setTimeout(() => {
        this.btnDisabled = false;
      }, 5000);

      const sendParams = {
        style: this.localConfig.style,
        payment: this.getUserInfo.payment ? 1 : 2,
        prompt: this.localConfig.prompt,
      };

      sendAli(this.aLiId, "generate_text_tattoo", sendParams);

      const params = {
        prompt: this.localConfig.prompt,
        text_style: this.localConfig.style,
      }

      // 将参数传到父组件来发起请求
      this.$emit("generateEmit", params);
    },
    // 通知内容已加载完成
    notifyContentLoaded() {
      this.$root.$emit("content-loaded");
    },
    // 处理从templates页面传来的提示词
    handleTemplatePrompt(prompt) {
      // 设置提示词
      if (prompt) {
        this.localConfig.prompt = prompt;
      }

      // 通知内容已更新
      this.$nextTick(() => {
        this.notifyContentLoaded();
      });
    },

    // 计算字符数的方法
    countChars() {
      const text = this.localConfig.prompt.trim();
      this.charCount = text ? text.length : 0;
      if (this.charCount > 0) {
        this.btnDisabled = false;
      }
    },
  },
  mounted() {
    // 监听从templates页面传过来的事件
    this.$root.$on("use-template-prompt", this.handleTemplatePrompt);

    // 监听从index页面强制设置Custom模式的事件
    this.$root.$on("force-custom-mode", this.handleTemplatePrompt);

    // 监听风格选择事件
    this.$root.$on("use-template-style", this.handleTemplateStyle);

    // 组件加载完成后通知
    this.$nextTick(() => {
      this.notifyContentLoaded();
      // 确保初始时计算一次字符数
      this.countChars();
    });
  },
  beforeDestroy() {
    // 清理事件监听器
    this.$root.$off("use-template-prompt", this.handleTemplatePrompt);
    this.$root.$off("force-custom-mode", this.handleTemplatePrompt);
    this.$root.$off("use-template-style", this.handleTemplateStyle);
  },
};
